
function DatenschutzPage() {
  return (
    <div className="min-h-screen bg-white py-16 px-4">
      <article className="max-w-[720px] mx-auto" style={{ lineHeight: 1.6 }}>
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">Datenschutzerklärung</h1>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">1. Verantwortlicher</h2>
        <p className="mb-4">
          Sportverein Heinersreuth 1921 e.V., Bayreuther Str. 47, 95500 Heinersreuth, Deutschland, E-Mail: <a href="mailto:info@sv-heinersreuth.de" className="text-gray-600 hover:underline">info@svheinersreuth-padel.de</a>, Telefon: 0921 / 45533.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">2. Zwecke und Rechtsgrundlagen</h2>
        <p className="mb-4">
          Personenbezogene Daten verarbeiten wir zur Bereitstellung der Website, zur Verwaltung von Padel-/Tennisplatz-Buchungen sowie zur Kommunikation. Rechtsgrundlagen: Art. 6 Abs. 1 lit. b DSGVO (Vertrag/Buchung) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse: Betrieb, IT-Sicherheit, Bedienbarkeit). Analyse- und Marketing-Technologien sind derzeit nicht aktiv.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">3. Hosting und Domain</h2>
        <p className="leading-relaxed mb-4">
          Die Website wird technisch über Bolt.new bereitgestellt. Die Domain wird bei GoDaddy registriert/gehalten. Beim Aufruf der Seiten verarbeitet der Hosting-Dienst automatisch Server-Logdaten (IP-Adresse, Datum/Uhrzeit, abgerufene URL, Referrer-URL, User-Agent). Die Speicherung erfolgt zur Gewährleistung der IT-Sicherheit für eine kurze, zweckgebundene Dauer und auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">4. Buchungen und Automatisierungen</h2>
        <p className="leading-relaxed mb-4">
          Zur technischen Automatisierung von Bestätigungen und Abläufen verwenden wir Make.com. Verarbeitete Daten: Name, Kontaktdaten, Buchungsdetails (Datum, Uhrzeit, Platz), ggf. Rechnungsdaten. Mit den genannten Dienstleistern bestehen Auftragsverarbeitungsverträge gemäß Art. 28 DSGVO.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">5. Zahlungen</h2>
        <p className="leading-relaxed mb-4">
          Online-Zahlungen werden über PayPal abgewickelt. Kreditkartenzahlungen erfolgen über PayPal Checkout. Die Zahlungsdienstleister erhalten die zur Zahlungsabwicklung erforderlichen Daten (Zahlungsbetrag, Zahlungsquelle, Transaktionskennungen, Name, Kontakt- und Rechnungsangaben). Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">6. Kommunikation</h2>
        <p className="leading-relaxed mb-4">
          Kontaktanfragen per Formular, E-Mail oder Telefon verarbeiten wir zur Bearbeitung und speichern sie bis zum Abschluss der Anfrage oder entsprechend gesetzlicher Aufbewahrungsfristen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">7. Cookies und technische Daten</h2>
        <p className="mb-4">
          <strong>Rechtsgrundlagen:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherem, funktionsfähigem Betrieb).
        </p>
        <p className="mb-4">
          <strong>Datenübermittlung in Drittländer:</strong> Bei Nutzung der Zahlungsdienste kann eine Übermittlung personenbezogener Daten in Drittstaaten außerhalb der EU/EWR erfolgen. Soweit erforderlich, erfolgt dies auf Grundlage geeigneter Garantien (z. B. EU-Standardvertragsklauseln).
        </p>
        <p className="mb-4">
          <strong>Aktueller Stand:</strong> Zum Zeitpunkt der Veröffentlichung werden keine Statistik- oder Marketing-Tools eingesetzt. Sollten künftig zusätzliche Dienste hinzukommen, passen wir diese Erklärung entsprechend an.
        </p>
        <p className="text-sm text-slate-600 italic mb-4">Stand: 06.11.2025</p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">8. Zugangskontrolle</h2>
        <p className="leading-relaxed mb-4">
          Zur Zugangskontrolle während gebuchter Zeitfenster können technische Daten wie Buchungs-ID, Zeitstempel und autorisierte Kennungen verarbeitet werden. Zweck ist die Sicherstellung des Zutritts nur für gültige Buchungen. Rechtsgrundlagen sind Art. 6 Abs. 1 lit. b und lit. f DSGVO.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">9. Empfänger und Drittlandübermittlungen</h2>
        <p className="leading-relaxed mb-4">
          Empfänger im Rahmen der Auftragsverarbeitung sind Bolt.new (Hosting), Make.com sowie PayPal. Soweit Daten außerhalb der EU/EWR verarbeitet werden, erfolgt dies auf Grundlage geeigneter Garantien (Art. 46 DSGVO, Standardvertragsklauseln).
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">10. Speicherdauer</h2>
        <p className="leading-relaxed mb-4">
          Daten werden gelöscht, sobald der Zweck entfällt und keine Aufbewahrungspflichten entgegenstehen. Buchungs- und Abrechnungsdaten werden nach steuerrechtlichen Vorgaben bis zu zehn Jahre aufbewahrt.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">11. Rechte der betroffenen Personen</h2>
        <p className="leading-relaxed mb-4">
          Betroffene haben Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit, Widerspruch sowie Widerruf erteilter Einwilligungen. Beschwerden können bei der zuständigen Datenschutzaufsichtsbehörde eingereicht werden.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">12. Pflichtangaben</h2>
        <p className="leading-relaxed mb-4">
          Für Buchungen erforderliche Angaben sind als Pflichtfelder gekennzeichnet; ohne diese ist keine Reservierung möglich.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">13. Datenschutzkontakt</h2>
        <p className="leading-relaxed mb-4">
          Anfragen zum Datenschutz: <a href="mailto:info@svheinersreuth-padel.de" className="text-gray-600 hover:underline">info@svheinersreuth-padel.de</a>. Ein Datenschutzbeauftragter ist nicht benannt.
        </p>

      </article>
    </div>
  );
}

export default DatenschutzPage;
